import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTurningAngle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 73.551,
	height: 34.802,
	viewBox: "0 0 73.551 34.802",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_147",
		"data-name": "Group 147",
		transform: "translate(0.5 0.5)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_47",
			"data-name": "Rectangle 47",
			width: 72.551,
			height: 33.802,
			transform: "translate(0)",
			fill: "none",
			stroke: "#040505",
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_146",
			"data-name": "Group 146",
			transform: "translate(5.67 1.727)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_289",
					"data-name": "Path 289",
					d: "M879.273,271.434a14.457,14.457,0,0,0-3.864-.942c-.484-.073-.941-.143-1.2-.206-.2-.049-.442-.123-.709-.2-1.567-.473-4.826-1.459-5.781,1.21a2.643,2.643,0,0,0,.409,2.733l-3.26-1.483a1.056,1.056,0,1,0-.875,1.921L869,276.741a1.055,1.055,0,0,0,1.4-.524,1.042,1.042,0,0,0,.051-.721c.45.172.912.325,1.358.469a12.486,12.486,0,0,1,1.54.565,3.42,3.42,0,0,1,.748.532,1.054,1.054,0,0,0-.09,1.956l5.006,2.277a1.043,1.043,0,0,0,.436.1,1.053,1.053,0,0,0,.682-1.856,3.116,3.116,0,0,0,2.229-1.476,3.619,3.619,0,0,0,.348-2.936A6.487,6.487,0,0,0,879.273,271.434Zm1.268,5.552c-.438.743-1.915.605-3.033.051a6.445,6.445,0,0,1-1.629-1.206,6.564,6.564,0,0,0-1.594-1.193,13.855,13.855,0,0,0-1.829-.682c-1.051-.339-2.49-.8-2.776-1.386-.028-.056-.1-.206.027-.566h0c.1-.28.385-.4.818-.4a9.321,9.321,0,0,1,2.364.5c.308.094.587.177.819.233.35.086.83.158,1.385.243a13.558,13.558,0,0,1,3.242.746,4.511,4.511,0,0,1,2.349,2.4A1.515,1.515,0,0,1,880.541,276.986Z",
					transform: "translate(-829.554 -257.993)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_290",
					"data-name": "Path 290",
					d: "M845.588,290.19a8.535,8.535,0,0,0-2.6.445,4.709,4.709,0,0,1-1.355.273,12.577,12.577,0,0,1-1.631-.179c-1.628-.242-3.472-.517-4.7.42a2.747,2.747,0,0,0-1.04,1.95h0c-.33,2.816,3.027,3.381,4.641,3.652.275.047.524.088.727.133.259.058.7.2,1.167.349a14.442,14.442,0,0,0,3.878.872,6.487,6.487,0,0,0,4.716-1.779,3.617,3.617,0,0,0,.993-2.784C850.227,291.342,847.851,290.19,845.588,290.19Zm2.26,4.7a4.508,4.508,0,0,1-3.169,1.106,13.578,13.578,0,0,1-3.235-.772c-.535-.172-1-.32-1.349-.4-.233-.052-.521-.1-.838-.155-1.8-.3-2.974-.643-2.895-1.324h0c.045-.379.177-.48.227-.518a1.817,1.817,0,0,1,1.042-.22,15.105,15.105,0,0,1,2.061.211,13.807,13.807,0,0,0,1.942.2,6.556,6.556,0,0,0,1.958-.361,6.454,6.454,0,0,1,2-.357c1.247,0,2.631.533,2.693,1.393A1.514,1.514,0,0,1,847.848,294.888Z",
					transform: "translate(-815.799 -267.758)",
					fill: "#040505",
					opacity: .3
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_291",
					"data-name": "Path 291",
					d: "M892.379,251a1.059,1.059,0,0,0,.4-.078l2.933-1.192a1.056,1.056,0,0,0-.794-1.956l-2.934,1.192a1.056,1.056,0,0,0,.4,2.034Z",
					transform: "translate(-842.75 -247.692)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_292",
					"data-name": "Path 292",
					d: "M866.447,260.108a1.045,1.045,0,0,0,.4-.078l6.844-2.779a1.056,1.056,0,0,0-.795-1.956l-6.844,2.78a1.056,1.056,0,0,0,.4,2.034Z",
					transform: "translate(-830.506 -251.245)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_293",
					"data-name": "Path 293",
					d: "M840.515,270.641a1.058,1.058,0,0,0,.4-.078l3.778-1.534a1.068,1.068,0,0,0,.123.072l2.883,1.312a1.056,1.056,0,1,0,.874-1.922l-1.2-.548.391-.159a1.056,1.056,0,0,0-.795-1.956l-6.844,2.78a1.056,1.056,0,0,0,.4,2.034Z",
					transform: "translate(-818.261 -256.218)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_294",
					"data-name": "Path 294",
					d: "M814.569,272.514a2.954,2.954,0,0,0-.063-1.518,3.617,3.617,0,0,0-1.933-2.237,6.49,6.49,0,0,0-5.04.048,14.453,14.453,0,0,0-3.3,2.217c-.381.308-.741.6-.961.747-.172.115-.389.243-.629.386-1.407.837-4.333,2.578-3.006,5.085a2.749,2.749,0,0,0,1.675,1.441,2.819,2.819,0,0,0,.792.109,8.267,8.267,0,0,0,3.739-1.417,12.564,12.564,0,0,1,1.455-.757,4.7,4.7,0,0,1,1.362-.236,8.538,8.538,0,0,0,2.583-.526c.078-.03.153-.064.229-.1a1.046,1.046,0,0,0,.7-.033l2.934-1.192a1.054,1.054,0,0,0-.537-2.021Zm-6.079,1.764a6.582,6.582,0,0,0-1.956.372,13.93,13.93,0,0,0-1.737.891c-.959.547-2.276,1.294-2.9,1.115-.06-.018-.22-.065-.4-.4-.321-.607.655-1.351,2.22-2.282.277-.165.526-.314.724-.447.3-.2.677-.506,1.114-.86a13.515,13.515,0,0,1,2.736-1.89,5.574,5.574,0,0,1,1.984-.387,3.189,3.189,0,0,1,1.371.271,1.513,1.513,0,0,1,.835.956c.253.825-.846,1.823-2.008,2.274A6.449,6.449,0,0,1,808.49,274.278Z",
					transform: "translate(-799.3 -257.411)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_295",
					"data-name": "Path 295",
					d: "M905.685,293.74l-2.882-1.312a1.056,1.056,0,1,0-.874,1.922l2.882,1.311a1.055,1.055,0,0,0,.874-1.921Z",
					transform: "translate(-847.466 -268.77)",
					fill: "#040505"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_296",
					"data-name": "Path 296",
					d: "M907.952,270.2a1.055,1.055,0,0,0-1.253-.812l-1.356.289a13.749,13.749,0,0,0-1.45-16.619l1.487.3a1.1,1.1,0,0,0,.207.02,1.056,1.056,0,0,0,.2-2.091l-3.9-.775c-.028-.005-.054,0-.082-.007a1.05,1.05,0,0,0-1.16.838l-.775,3.9a1.055,1.055,0,0,0,.83,1.241,1.069,1.069,0,0,0,.207.021,1.056,1.056,0,0,0,1.035-.85l.258-1.3a11.51,11.51,0,0,1,2.307,3.592,11.638,11.638,0,0,1-.97,10.638l-.306-1.436a1.056,1.056,0,1,0-2.065.44L902,271.47a1.056,1.056,0,0,0,1.253.812l3.888-.829A1.056,1.056,0,0,0,907.952,270.2Z",
					transform: "translate(-846.779 -249.015)",
					fill: "#040505"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgTurningAngle);
export { ForwardRef as ReactComponent };
